// src/store/modifJson/procedureActions.js
export const FETCH_PROCEDURE_DATA = 'FETCH_PROCEDURE_DATA';
export const FETCH_PROCEDURE_DATA_REQUEST = 'FETCH_PROCEDURE_DATA_REQUEST';
export const FETCH_PROCEDURE_DATA_SUCCESS = 'FETCH_PROCEDURE_DATA_SUCCESS';
export const FETCH_PROCEDURE_DATA_FAILURE = 'FETCH_PROCEDURE_DATA_FAILURE';
export const UPDATE_STAGES = 'UPDATE_STAGES';
export const SAVE_PROCEDURE_DATA_REQUEST = 'SAVE_PROCEDURE_DATA_REQUEST';
export const SAVE_PROCEDURE_DATA_SUCCESS = 'SAVE_PROCEDURE_DATA_SUCCESS';
export const SAVE_PROCEDURE_DATA_FAILURE = 'SAVE_PROCEDURE_DATA_FAILURE';
export const ADD_STEP_REQUEST = 'ADD_STEP_REQUEST';
export const ADD_STEP_SUCCESS = 'ADD_STEP_SUCCESS';
export const ADD_STEP_FAILURE = 'ADD_STEP_FAILURE';
export const SET_SETTINGS = 'SET_SETTINGS';

export const setSettings = (settings) => ({
  type: SET_SETTINGS,
  payload: settings
});

export const updateStages = (stages) => ({
  type: UPDATE_STAGES,
  payload: stages
});

export const saveProcedureDataRequest = (data) => ({
  type: SAVE_PROCEDURE_DATA_REQUEST,
  payload: data
});

export const saveProcedureDataSuccess = (data) => ({
  type: SAVE_PROCEDURE_DATA_SUCCESS,
  payload: data
});

export const saveProcedureDataFailure = (error) => ({
  type: SAVE_PROCEDURE_DATA_FAILURE,
  payload: error
});

export const addStepRequest = (stepData) => ({
  type: ADD_STEP_REQUEST,
  payload: stepData
});

export const addStepSuccess = (stepData) => ({
  type: ADD_STEP_SUCCESS,
  payload: stepData
});

export const addStepFailure = (error) => ({
  type: ADD_STEP_FAILURE,
  payload: error
});

export const fetchProcedureDataRequest = () => ({
    type: FETCH_PROCEDURE_DATA_REQUEST,
});

export const fetchProcedureDataSuccess = (data, folderName, filename) => ({
    type: FETCH_PROCEDURE_DATA_SUCCESS,
    payload: { data, folderName, filename, stages: data?.chapter?.stages || [], steps: data?.chapter?.steps || [] },
});

export const fetchProcedureDataFailure = (error) => ({
    type: FETCH_PROCEDURE_DATA_FAILURE,
    payload: error,
});

export const fetchProcedureData = (folderName, filename) => ({
    type: FETCH_PROCEDURE_DATA,
    payload: { folderName, filename },
});


//Creators : Florian Cohen-Joly @3DDGAMES -- Under license